import apiClient from './client'
import type { AxiosResponse } from './client'
import type { Content, ContentFilters, ContentStats, PaginatedContent } from '@/types/content'
import { CONTENT } from './endpoints'

export const contentApi = {
  async list(filters?: ContentFilters): Promise<PaginatedContent> {
    const params = new URLSearchParams()
    
    // Always include pagination parameters with defaults
    params.append('page', (filters?.page || 1).toString())
    params.append('page_size', (filters?.page_size || 10).toString())
    
    if (filters) {
      if (filters.source) params.append('source', filters.source)
      if (filters.language) params.append('language', filters.language)
      if (filters.analyzed !== undefined) params.append('analyzed', filters.analyzed.toString())
      if (filters.is_important !== undefined) params.append('is_important', filters.is_important.toString())
      if (filters.start_date) params.append('start_date', filters.start_date)
      if (filters.end_date) params.append('end_date', filters.end_date)
      if (filters.sort_by) params.append('sort_by', filters.sort_by)
      if (filters.sort_order) params.append('sort_order', filters.sort_order)
      if (filters.search) params.append('search', filters.search)
      if (filters.relevance) params.append('relevance', filters.relevance)
    }
    
    const response = await apiClient.get(`${CONTENT.LIST}?${params.toString()}`)
    return response.data
  },

  async get(id: string): Promise<Content> {
    const response: AxiosResponse<Content> = await apiClient.get(CONTENT.GET(id))
    return response.data
  },

  async analyze(id: string): Promise<Content> {
    const response: AxiosResponse<Content> = await apiClient.post(CONTENT.ANALYZE(id))
    return response.data
  },

  async analyzeMultiple(ids: string[]): Promise<void> {
    await apiClient.post('/api/content/analyze-multiple', { ids })
  },

  async getStats(): Promise<ContentStats> {
    const response: AxiosResponse<ContentStats> = await apiClient.get('/api/content/stats')
    return response.data
  },

  async update(id: string, data: Partial<Content>): Promise<Content> {
    console.log(`API: Updating content ${id} with data:`, data)
    
    // Ensure we're sending the data in the correct format
    const response: AxiosResponse<Content> = await apiClient.put(CONTENT.UPDATE(id), data)
    
    console.log(`API: Update response for content ${id}:`, response.data)
    return response.data
  },

  async updateLanguage(id: string, language: string): Promise<Content> {
    console.log(`API: Updating language for content ${id} to ${language}`)
    
    const response: AxiosResponse<Content> = await apiClient.patch(CONTENT.UPDATE_LANGUAGE(id), { language })
    
    console.log(`API: Language update response for content ${id}:`, response.data)
    return response.data
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(CONTENT.DELETE, { params: { ids: id } })
  }
} 